export enum ChartType {
    // datatable = 0,
    doughnut = 'Doughnut',
    bar = 'Bar',
    horizontalBar = 'HorizontalBar',
    line = 'Line',
    radar = 'radar'
    // sunburst
}
